<div *ngIf="!!show" class="loadingio-spinner-dual-ball-ivijmhfea8l">
  <div class="ldio-7b7ivntsept">
    <div></div><div></div><div></div>
  </div>
</div>

<div *ngIf="!!show" class="loader-backdrop"></div>
